import { Component } from '@angular/core';
import { EnvironmentService } from '../services/environment/environment.service';
import { ActivatedRoute } from '@angular/router';

const defaultAppColor = '#79b700';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: false
})
export class MaintenanceComponent {
  appColor = defaultAppColor;

  constructor(environmentService: EnvironmentService, route: ActivatedRoute) {
    const path = route.snapshot.url[0]?.path;
    this.appColor =
      environmentService.getAppsArray().find((x) => x.path === path)?.color
        ?.primary || defaultAppColor;
  }
}
